import React from 'react';
import { RentReportingBoundary } from '../../components/RentReportingBoundary';
import EnrollmentPage from '../../components/EnrollmentPage';

export default function Enroll() {
  return (
    <RentReportingBoundary requireAuth={false}>
      <EnrollmentPage />
    </RentReportingBoundary>
  );
}
